import { useTranslation } from 'react-i18next'

import { validateJSON } from '@/common/utils/validateJSON'
import { z } from '@/lib/zod'

export function EditApplicationSchema() {
  const { t } = useTranslation('sso')

  return z.object({
    applicationKey: z.string().min(1).max(100),
    title: z.string().min(1).max(100),
    description: z.string().optional(),
    tag: z
      .array(
        z.object({
          label: z.string(),
          value: z.string(),
          __isNew__: z.boolean().optional(),
        }),
      )
      .nonempty(),
    auth: z
      .string()
      .min(1)
      .refine((val) => validateJSON(val), {
        message: t(
          'applications.drawer_edit_application.schema.auth.invalid_json',
        ),
      }),
    metadata: z
      .string()
      .optional()
      .refine(
        (val) => {
          if (!val) return true
          return validateJSON(val)
        },
        {
          message: t(
            'applications.drawer_edit_application.schema.metadata.invalid_json',
          ),
        },
      ),
  })
}

export type EditApplicationForm = z.infer<
  ReturnType<typeof EditApplicationSchema>
>
